"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Item.scss");
const Item = _ref => {
  let {
    icon,
    href,
    title,
    isActive,
    hasBadge,
    onLinkClick,
    className
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-AccountMenu-Item', {
    'cds-AccountMenu-Item--Active': isActive
  }, className);
  const handleLinkClick = e => {
    e.preventDefault();
    onLinkClick(href);
  };
  return /*#__PURE__*/_react.default.createElement("li", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    onClick: handleLinkClick,
    className: "cds-AccountMenu-ItemLink"
  }, icon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: icon,
    size: _Icon.ICON_SIZE.small,
    className: "cds-AccountMenu-ItemIcon"
  }), title), hasBadge && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-AccountMenu-ItemBadge"
  }));
};
exports.Item = Item;
//# sourceMappingURL=Item.js.map